import React from 'react';
import { MdFileDownload, MdBackHand } from "react-icons/md";
import { Row, Col } from "react-grid-system";
import Projects from '../components/projects';
import BlockTitle from '../components/blockTitle';
import Button from '../components/button';
import CardSkill from '../components/cardSkill';
import Awards from '../components/awards';
import CardEdu from '../components/cardEdu';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { FaGraduationCap, FaBriefcase } from "react-icons/fa";
import ContactForm from '../components/contactForm';
import { FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { ProfileData, aboutData } from '../helpers/constants';
import { projectData } from '../helpers/constants';
import { awardContent} from '../helpers/constants';


function Home() {
  return (
    <>
      <section className='profile-block' id='profile'>
        <div className="custom-container">
          <Row className='row'>
            <Col lg={5} className="right">
              <div data-aos="fade-down" data-aos-delay="1000" className="profile-media">
                <img src={ProfileData?.profile_image} alt={ProfileData?.profile_image_alt} />
              </div>
            </Col>
            <Col lg={7}>
              <div className="left">
                <h1 data-aos="fade-down-right" data-aos-delay="500">{ProfileData?.profileName} <MdBackHand /></h1>
                <div data-aos="fade-up" dangerouslySetInnerHTML={{ __html: ProfileData?.profile_desc }}></div>
                <div className="social-links">
                  <span>{ProfileData?.socialData?.socialHeading}</span>
                  <ul>
                    <li className='linkedin'><a href={ProfileData?.socialData?.socialLink1} rel="noreferrer" target='_blank'><FaLinkedinIn /></a></li>
                    <li className='youtube'><a href={ProfileData?.socialData?.socialLink2} rel="noreferrer" target='_blank'><FaYoutube /></a></li>
                  </ul>
                </div>

                <div className="btn-wrap">
                  <a href={ProfileData?.buttons?.button_1_url}>
                    <Button
                      extraClass='btn-primary'
                      buttonText={ProfileData?.buttons?.button_1_title}
                    />
                  </a>
                  <a href={ProfileData?.buttons?.button_2_url}>
                    <Button
                      extraClass='btn-primary sl-duration'
                      buttonText={ProfileData?.buttons?.button_2_title}
                    />
                  </a>
                  
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>


      <section className='about-block' id='about'>
        <div className="custom-container">
          <Row className='row'>
            <Col lg={6} className="about-left">
              <div data-aos="flip-right" className="about-left__media">
                <img src={aboutData?.about_media} alt={aboutData?.about_media_alt} />
              </div>
            </Col>
            <Col lg={6} className="about-right">
              <div className="about-right__content">
                <div data-aos="fade-up" data-aos-delay="500">
                <BlockTitle
                  extraClass='block-title--alt'
                  mainTitle={aboutData?.block_title}
                />
                </div>
                <div data-aos="fade-up" dangerouslySetInnerHTML={{ __html: aboutData?.about_desc }}></div>
                <div className="btn-wrap">
                  <a href={aboutData?.download_cv_btn_url} target="_blank" rel="noreferrer">
                    <Button
                      extraClass='btn-primary'
                      buttonText={aboutData?.download_cv_btn_title}
                      btnIcon={<MdFileDownload />}
                    />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className='tab-block' id='tab-section'>
        <div className="custom-container">
          <Tabs>
            <TabList>
              <Tab data-aos="zoom-out-right">Education<FaGraduationCap /></Tab>
              <Tab data-aos="zoom-out-left">Experience<FaBriefcase /></Tab>
            </TabList>

            <TabPanel>
              <Row className='row'>
              <Col lg={12} className="col">
                    <div data-aos="fade-right">
                    <CardEdu
                      programme_title = "Master of Science in Electrical and Computer Engineering"
                      college_name = "Southern Illinois University Edwardsville"
                      percentage = "4.0/4.0"
                      duration = "2024-2026"
                    />
                    </div>
                  </Col>
                  <Col lg={12} className="col">
                    <div data-aos="fade-right">
                    <CardEdu
                      programme_title = "Bachelor of Technology in Electrical and Electronics Engineering"
                      college_name = "Uttarakhand Technical University"
                      percentage = "83%"
                      duration = "2018-2022"
                    />
                    </div>
                  </Col>
                  <Col lg={12} className="col">
                    <div data-aos="fade-right">
                    <CardEdu
                      programme_title = "Higher Secondary School"
                      college_name = "Model Multiple College"
                      percentage = "65%"
                      duration = "2014-2016"
                    />
                    </div>
                  </Col>
              </Row>
            </TabPanel>
            <TabPanel>
              <Row>
              <Col lg={12} className="col">
                    <div data-aos="fade-right">
                    <CardEdu
                      programme_title = "Project Manager"
                      college_name = "Smartsites Nepal Pvt. Ltd."
                      duration = "2022/Sep-2023/Dec"
                    />
                    </div>
                  </Col>
                  <Col lg={12} className="col">
                    <div data-aos="fade-right">
                    <CardEdu
                      programme_title = "Junior Engineer"
                      college_name = "Nepal Electricity Authority"
                      duration = "2022/Mar-2022/Jul"
                    />
                    </div>
                  </Col>
              </Row>
            </TabPanel>
          </Tabs>
        </div>
      </section>

      <section className='skills-block' id='skill'>
        <div className="custom-container">
          <div data-aos="fade-up" data-aos-delay="500">
          <BlockTitle
            mainTitle="Skills"
          />
          </div>
          <Row className='row'>
              <Col lg={4} md={6}  style={{ marginBottom: "25px" }} >
                <div data-aos="fade-up" data-aos-delay="1000">
                <CardSkill
                  title="Frontend"
                 list="<ul><li>HTML</li><li>CSS</li><li>JavaScript</li><li>React</li><li>Vue</li></ul>"
                />
                </div>
              </Col>
              <Col lg={4} md={6}  style={{ marginBottom: "25px" }} >
                <div data-aos="fade-up" data-aos-delay="1000">
                <CardSkill
                  title="Microsoft Office"
                 list="<ul><li>Microsoft word</li><li>Microsoft Excel</li><li>Microsoft Powerpoint</li><li>Google sheet</li></ul>"
                />
                </div>
              </Col>
              <Col lg={4} md={6}  style={{ marginBottom: "25px" }} >
                <div data-aos="fade-up" data-aos-delay="1000">
                <CardSkill
                  title="Matlab"
                 list="<ul>
                  <li>Simulink</li>
                  <li>Programing</li>
                 </ul>"
                />
                </div>
              </Col>
              <Col lg={4} md={6}  style={{ marginBottom: "25px" }} >
                <div data-aos="fade-up" data-aos-delay="1000">
                <CardSkill
                  title="Power World Simulator"
                 list="<ul>
                  <li>Designing</li>
                  <li>Load simulation</li>
                 </ul>"
                />
                </div>
              </Col>
              <Col lg={4} md={6}  style={{ marginBottom: "25px" }} >
                <div data-aos="fade-up" data-aos-delay="1000">
                <CardSkill
                  title="Programming"
                 list="<ul>
                  <li>Python</li>
                  <li>C</li>
                 </ul>"
                />
                </div>
              </Col>
          </Row>
        </div>
      </section>

      <section className='projects-block' id='projects'>
        <div className="custom-container">
          <div data-aos="fade-up" data-aos-delay="500">
          <BlockTitle
            mainTitle="Projects"
          />
          </div>
          {projectData.map((item, index) =>
            <Projects
              allContent={item}
              key={index}
            />
          )}
        </div>
      </section>

      <section className='awards-block' id='awards'>
        <div className="custom-container">
          <div data-aos="fade-up" data-aos-delay="500">
          <BlockTitle
            mainTitle='Leadership and Award'
          />
          </div>
          {awardContent.map((item, index) =>
            <Awards
              awardContent={item}
              key={index}
            />
          )}
        </div>
      </section>
      <section className='awards-block inetrest' id='awards'>
        <div className="custom-container">
          <div data-aos="fade-up" data-aos-delay="1000">
          <BlockTitle
            mainTitle="Current project and Interest"
          />
          </div>
          {awardContent.map((item, index) =>
            <Awards
              awardContent={item}
              key={index}
            />
          )}
        </div>
      </section>

      <section className='contact-block' id='contact'>
        <div className="custom-container">
          <ContactForm />
        </div>
      </section>
    </>
  );
}

export default Home;